import { render, staticRenderFns } from "./detailMobile.vue?vue&type=template&id=22af00e8&scoped=true&"
import script from "./detailMobile.vue?vue&type=script&lang=js&"
export * from "./detailMobile.vue?vue&type=script&lang=js&"
import style0 from "./detailMobile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./detailMobile.vue?vue&type=style&index=1&id=22af00e8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af00e8",
  null
  
)

export default component.exports